<template>
    <ion-grid class="loading">
        <ion-row align-items-center>
            <ion-col>
                <ion-list text-center>
                    <ion-item lines="none">
                        <svg class="rotate-vert-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 533.33331 533.33331" height="150" width="150" xml:space="preserve" id="logo-loading" version="1.1">
                            <defs id="defs66" />
                            <g transform="matrix(1.3333333,0,0,-1.3333333,0,533.33333)" id="g70">
                                <path d="m 200,342.321 c -58.473,0 -106.0426,-47.57 -106.0426,-106.042 0,-20.156 5.7067,-39.794 16.5036,-56.786 0.068,-0.108 0.139,-0.217 0.211,-0.322 l 10.145,-15.006 c 0.108,-0.178 0.174,-0.369 0.291,-0.543 0.197,-0.294 0.422,-0.557 0.638,-0.83 l 6.868,-10.16 9.179,6.173 c 0.721,0.318 1.428,0.682 2.104,1.137 l 76.11,51.181 37.459,25.189 c 6.204,4.171 7.851,12.584 3.68,18.789 -4.171,6.205 -12.585,7.854 -18.791,3.68 l -22.969,-15.447 -48.299,16.984 c -7.057,2.485 -14.783,-1.227 -17.263,-8.28 -2.48,-7.054 1.227,-14.784 8.28,-17.264 l 29.254,-10.287 -51.311,-34.504 -2.831,4.188 c -7.968,12.608 -12.181,27.164 -12.181,42.108 0,43.541 35.423,78.964 78.965,78.964 43.541,0 78.965,-35.423 78.965,-78.964 0,-14.955 -4.217,-29.519 -12.197,-42.133 L 200,95.391 l -33.75,49.92 -22.47,-15.11 45.004,-66.5658 c 2.517,-3.725 6.721,-5.9563 11.216,-5.9563 4.495,0 8.698,2.2313 11.216,5.9563 L 289.31,179.143 c 0.071,0.104 0.139,0.211 0.209,0.317 10.809,16.999 16.523,36.646 16.523,56.819 0,58.472 -47.569,106.042 -106.042,106.042" style="fill:#ff0055;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:1.97475005;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none" id="path76" />
                            </g>
                        </svg>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label class="loading-msg" text-center>{{msg}}</ion-label>
                    </ion-item>
                    <ion-item lines="none" v-if="note">
                        <ion-note class="loading-msg" text-center>{{note}}</ion-note>
                    </ion-item>
                </ion-list>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
export default {
  name: 'Loading',
  props: {
      msg: String,
      note: String,
  },
};
</script>

<style scoped>
    ion-item {
        --background: none;
        margin: 0 auto;
    }

    ion-list {
        background: none;
        padding: 0;
    }

    ion-list ion-label {
        font-size: .8em !important;
    }

    .loading {
        height: 100%;
    }

    .loading-msg {
        color: #666;
    }

    .rotate-vert-center {
        margin: 0 auto;
        -webkit-animation: rotate-vert-center 1s ease-in-out infinite both;
        animation: rotate-vert-center 1s ease-in-out infinite both;
    }

    @-webkit-keyframes rotate-vert-center {
        0% {
            -webkit-transform: rotateY(0);
            transform: rotateY(0);
        }
        100% {
            -webkit-transform: rotateY(360deg);
            transform: rotateY(360deg);
        }
    }
    @keyframes rotate-vert-center {
        0% {
            -webkit-transform: rotateY(0);
            transform: rotateY(0);
        }
        100% {
            -webkit-transform: rotateY(360deg);
            transform: rotateY(360deg);
        }
    }
</style>
